import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { storeToRefs } from 'pinia';
import { useRiskStore } from '@/stores/riskData';
import { getQuoteProductConfig } from '../config/productRegistry';

// Check to see if promo code box can be rendered. MTA never has a Promobox. 
// tenantPromoRules is in productRegistry.ts that determines if the promo code box should be shown for that product.
export function useShowPromoCodeBox(productId: MaybeRefOrGetter<string | null | undefined>) {
    const { riskData, action } = storeToRefs(useRiskStore());

    return computed(() => {
        if (String(action.value ?? '').toLowerCase().includes('mta')) return false;
        return getQuoteProductConfig(toValue(productId))?.tenantPromoRules?.(riskData.value) ?? false;
    });
}
